export default __webpack_public_path__ + "static/media/heros.d8f13885.jpg";